{
  "faq": [
    {
      "question": "Что можно создать с помощью Canva?",
      "answer": "Презентации, изображения, материалы для соцсетей, документы и другие визуальные форматы. Доступность конкретных функций проверяется на официальном сайте."
    },
    {
      "question": "Этот сайт является официальным сайтом Canva?",
      "answer": "Нет. Это независимый русскоязычный проект, который помогает выбрать нужный сценарий."
    },
    {
      "question": "Можно ли сначала посмотреть пример результата?",
      "answer": "Да. Каждая продуктовая страница строится вокруг демонстрации действия и результата."
    },
    {
      "question": "Где начать редактирование фотографии?",
      "answer": "Выберите редактор фото или одну конкретную задачу: удалить фон, заменить фон или изменить объект."
    },
    {
      "question": "Чем генератор изображений отличается от редактора фото?",
      "answer": "Генератор создаёт новый визуал по описанию, а редактор работает с уже загруженным изображением."
    }
  ]
}
